import Flex from '../Flex/Flex';
import theme from '../../assets/styles/theme';
import styled from 'styled-components';

const Body = styled(Flex)`
  position: relative;
  padding-right: 10px;
  padding-left: 10px;
  justify-content: space-evenly;
`;

const Footer = styled.div`
  background-color: white;
  position: absolute;
  bottom: -60px;
  border-top: 1px solid ${theme.oldColors['palette-buttons-primary-disabled']};
  width: 100%;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  box-shadow: 0 15px 40px 0 rgba(117, 117, 170, 0.08);
`;

const Buttons = styled(Flex)`
  justify-content: space-between;
  margin: 15px;
`;

const ButtonsRight = styled(Flex)`
  justify-content: flex-end;
  & button:last-child {
    margin-left: 15px;
  }
`;

const DateInput = styled(Flex)`
      justify-content: space-between;
      align-items: center;
      width: 210px;
      padding: 10px;
      font-size: 14px;
      color:  ${theme.oldColors['palette-neutral-n-1']};
      border: solid 1px ${theme.oldColors['palette-neutral-n-3']};
      border-radius: 5px;
      background-color: white;
      &:focus {
        border-color: ${theme.oldColors['palette-message-info']};
        $palette-message-info: #439aff;
      }
      & placeholder: ${theme.oldColors['palette-input-disabled-text']};
  `;

export { Body, Footer, Buttons, ButtonsRight, DateInput };
